"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeWorkflows_en_us = void 0;
function backofficeWorkflows_en_us() {
    return {
        "backoffice.workflows.widget.execute.title": "Workflow startet",
        "backoffice.workflows.widget.execute.message": "Would you now like to go to your task queue to see the progress of the running workflow?",
        "backoffice.workflows.widget.execute.buttons.gototaskbtn": "Go to \"task queue\"",
        "backoffice.workflows.widget.execute.buttons.close": "Close",
        "backoffice.workflows.title": "Workflows",
        "backoffice.workflows.all": "All Workflows",
        "backoffice.workflows.dashboard.title": "Dashboard",
        "backoffice.workflows.list.title": "List of all workflows",
        "backoffice.workflows.list.tabheader": "Workflows",
        "backoffice.workflows.tasks.title": "List of all tasks",
        "backoffice.workflows.tasks.tabheader": "Tasks",
        "backoffice.workflows.executions.manualexecute": "Execute manually",
        "backoffice.workflows.executions.templates": "Templates",
        "backoffice.workflows.executions.title": "Workflow Executions",
        "backoffice.workflows.executions.tabheader": "Executions",
        "backoffice.workflows.trigger.title": "Execute manually",
        "backoffice.workflows.trigger.message": "Do you really want to execute this workflow manually?",
        "backoffice.workflows.create.title": "Create Workflow",
        "backoffice.workflows.create.subtitle": "What label would you like to assign to your workflow?",
        "backoffice.workflows.detail.tabheader": "Details",
        "backoffice.workflows.detail.active.no": "Not Active",
        "backoffice.workflows.detail.active.always": "Active",
        "backoffice.workflows.detail.active.range": "Defined Time Range",
        "backoffice.workflows.detail.activate.title": "Activate workflow",
        "backoffice.workflows.detail.activate.message": "Do you really want to activate this workflow?",
        "backoffice.workflows.detail.deactivate.title": "Deactivate workflow",
        "backoffice.workflows.detail.deactivate.message": "Do you really want to deactivate this workflow?",
        "backoffice.workflows.detail.delete.title": "Delete Workflow",
        "backoffice.workflows.detail.delete.message": "Do you really want to delete this workflow?",
        "backoffice.workflows.detail.triggers.description": "You can either trigger your workflows manually or automate their execution, for example via time-based schedules. It's also possible to listen to events fired by the system itself.",
        "backoffice.workflows.detail.triggers.cronjob": "Time-based Schedule",
        "backoffice.workflows.detail.triggers.event": "System Event",
        "backoffice.workflows.detail.triggers.dialogtitle": "Event Selection",
        "backoffice.workflows.editor.deleteblock.title": "Delete Block",
        "backoffice.workflows.editor.deleteblock.message": "Do you really want to delete this workflow block?",
        "backoffice.workflows.editor.tabheader": "Editor",
        "backoffice.workflows.editor.dialog.title": "Add Workflow Block",
        "backoffice.workflows.editor.dialog.configinfo": "Configure the selected Workflow Block",
        "backoffice.workflows.editor.dialog.socketinfo": "Connect to the new workflow block via target socket.",
        "backoffice.workflows.editor.dialog.multisocket": "There is more than one connection possibility for this block. Choose the socket to which you want to connect to.",
        "backoffice.workflows.editor.dialog.sourcesocket": "Connect the new block to one of the following outgoing socket options.",
        "backoffice.workflows.editor.dialog.connect": "Connect",
        "backoffice.workflows.editor.config.title": "Configure Block",
        "backoffice.workflows.editor.config.noschema": "No schema found! Block is not configureable.",
        "backoffice.workflows.blocks.globalstore.title": "Global Storage",
        "backoffice.workflows.blocks.globalstore.description": "Stores incoming data in the global store",
        "backoffice.workflows.blocks.propertymapper.title": "Data Converter",
        "backoffice.workflows.blocks.propertymapper.description": "Converts the structure of incoming data into a structure of your choice"
    };
}
exports.backofficeWorkflows_en_us = backofficeWorkflows_en_us;
